import React from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'

import Modal from '../../../../UniformComponents/Modal'
import ModalHeader from '../../../../UniformComponents/ModalHeader'
import Button from '../../../../UniformComponents/Button'
import FilterPanel from './FilterPanel'
import RuleGroup from '../../../ReportV2/components/Modal/Filter/model/RuleGroup'

import './style.scss'

const FilterModal = observer(({ store }) => {
    const getQuestionFilterOptions = () => (
        store.surveyFilterQuestions.get(store.survey?.surveyId?.toUpperCase()) || []
    )

    const chartFilters = {
        question: store.activeChart?.filter?.question
            ?? new RuleGroup(RuleGroup.getDefaultLogic('question')),
    }

    return (
        <Modal
            show={store.filterModalOpen}
            onClose={store.handleCloseFilterModal}
            cssClass="ppbFilter"
        >
            <ModalHeader>
                <h3>{i18n.t('report.filter.h3')}</h3>
                <h4>{i18n.t('report.filter.h4')}</h4>
            </ModalHeader>
            <div className="body">
                <FilterPanel
                    key={store.currentChart}
                    title={i18n.t('report.filter.response.title')}
                    description={i18n.t('report.filter.response.description')}
                    optionTitle={i18n.t('report.filter.response.optionTitle')}
                    optionDescription={i18n.t('report.filter.response.optionDescription')}
                    filterTitle={i18n.t('report.filter.response.filterTitle')}
                    filterDescription={i18n.t('report.filter.response.filterDescription')}
                    store={store}
                    filterKey="question"
                    ruleGroup={chartFilters}
                    getFilterOptions={getQuestionFilterOptions}
                    onSave={store.handleSaveFilters}
                />
                <Button
                    label={i18n.t('close')}
                    cssClass="regular tertiary"
                    onClick={store.handleCloseFilterModal}
                />
            </div>
        </Modal>
    )
})

export default FilterModal
